import { Component, ViewChild, OnInit, Input, OnChanges, Inject } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import {usersResultService} from '../usersResultService';
import {Page} from "./datatable/page";
import { MatDialog,MatDialogRef  } from '@angular/material/dialog';
import { dialogComponent } from '../dialog/dialog.component';
import { CommonService } from '../shared/services/common.service';
import { APPCONFIG } from '../config'
import { FormControl } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import OktaAuth from '@okta/okta-auth-js';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';


@Component({
    selector: 'my-usersList',
    template: require('./usersList.component.html'),
    styles: [require('./usersList.component.scss'),require('../custom_style.scss')],
    providers: [HttpService,SessionHandler]
})

export class UsersListComponent {
    ipp: number = 10;

itemsPerPage= new FormControl(100);
@ViewChild('tableWrapper') tableWrapper;
@ViewChild(DatatableComponent) table: DatatableComponent;


    APPCONFIG;
    tableRows :any = [];
    page = new Page();
    public rows:any;
    dashboardData = [];
    temp = [];
    showTable:boolean = true;
    userData:any;
    dialogRef;
    reasonList:any;
    fileUrl:any;
    isApprover:boolean = false;
    showAction:boolean = false;
    isFS:boolean = false;
    isAdmin:boolean = false;
    public daterange: any = {};
    filters:any={};
    customFilters:any={};
    arrayKeys:any;
    showFilterList:boolean = false;
    userRole:any;
    isOTD:boolean = false;
    showLoader = false;
    siteId:any = undefined;
    private currentComponentWidth;
    rowToDel:string=null;
    accessToken: string;

    
    ngAfterViewChecked() {
        // Check if the table size has changed,
        if (this.table && this.table.recalculate && (this.tableWrapper.nativeElement.clientWidth !== this.currentComponentWidth)) {
          this.currentComponentWidth = this.tableWrapper.nativeElement.clientWidth;
          this.table.recalculate();
        //   this.cdr.detectChanges();
        }
      }

    pageLimit(limit:any): void {
        this.changePageLimit(limit);
        this.table.limit = this.ipp;
        this.table.recalculate();

        setTimeout(() => {
            if (this.table.bodyComponent.temp.length <= 0) {
              this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
            }
        });
    }

    private changePageLimit(limit: any): void {
        this.ipp = parseInt(limit, 10);
    }
    
    onPage(event) {
        this.table.limit = Number(this.itemsPerPage.value);
        // this.offset = event.offset;
    }

    constructor(private router: Router, private http:HttpService,private serverResultsService: usersResultService,private activatedRoute: ActivatedRoute
        ,private sessionHandler:SessionHandler,public dialog: MatDialog,private commonService : CommonService,private oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
        public httpService: HttpService) {
            this.page.pageNumber = 0;
            this.page.size = 10;
    
            this.oktaAuthStateService.authState$.subscribe(async (authState) => {
                console.log('authState', authState);
                if (authState.isAuthenticated) {
                    const tokens = await this.oktaAuth.tokenManager.getTokens();
                    this.accessToken = tokens.accessToken?.accessToken;
    
                    var today = new Date();
                    this.daterange.date = today.getDate();
                    if (today.getMonth() == 0 || today.getMonth() == 1) {
                        this.daterange.start_mm = 12;
                        this.daterange.end_mm = 2;
                        this.daterange.startYear = today.getFullYear() - 1;
                        this.daterange.endYear = today.getFullYear();
                    } else {
                        this.daterange.start_mm = today.getMonth() - 1;
                        this.daterange.end_mm = today.getMonth() + 1;
                        this.daterange.startYear = today.getFullYear();
                        this.daterange.endYear = today.getFullYear();
                    }
                    this.filters['offSet'] = this.page.pageNumber * this.page.size;
                    this.getDashboardData(this.filters);
                    this.commonService.setData(null);
                } else {
                    this.router.navigateByUrl('/extra/login');
                }
            });
        }
     

    public reloadData(){
       
        this.getDashboardData(this.filters);
    }
  

    public getDashboardData(filter){

        this.showLoader = true;
            let token = localStorage.getItem('userEmail');
            const httpOptions = {
                headers : new HttpHeaders({
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${this.accessToken}`
                  }) };

            console.log('API URL:', `${this.http.url}/users/list`);
            this.httpService.getRequestWithHeader('users/list', httpOptions).subscribe(
                res => {
                    console.log(res);
    
                    if(res['message'] == 'error_occured'){
    
                        this.showLoader = false;
            
                        this.http.onEnd();
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = res['exp']['message'];
            
                        this.dialogRef.afterClosed().subscribe(result => {
                            window.location.href = '#/app/users/list';
                        });
                        return;
                     }
    
    
                    const report_json = res['dataMap'];
                    console.log(report_json);                  
                     let items = report_json['usersList'];
                     var result = {'offSet':0,'limit':0,'items':items};

                     this.saveDashboardData(result,filter);
                    // let countriesArr = report_json['countries'];
                   
                    // for (var i in countriesArr) {
                    //     var obj = { "id": i, "name": countriesArr[i] };
                    //     countries += ','+i;
                    // }
                  
                    this.http.onEnd();
                    this.showLoader = false;
                    // this.buildForm();
    
    
                    },
                    err => {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                        this.showLoader = false;
                        this.http.onEnd();
                        }
            );  
          }


          public rowToDelete(userId){
            this.rowToDel = userId;
        }
        
        public deleteUser(){
        
            // debugger;
        
            if(this.rowToDel == null){
                return;
            }

    const user = {'id':this.rowToDel};
    // console.log(user);

    // let body = JSON.stringify(user);
    this.showLoader = true;

    let token = localStorage.getItem('userEmail');
    const httpOptions = {
      headers : new HttpHeaders({
            'Content-Type': 'application/json',
            // 'googleEmailId': token
            'Authorization': `Bearer ${this.accessToken}`
        }) };
    this.http.postRequestWithHeader(user,'users/delete',httpOptions).subscribe(
        res => {
            
             this.deleteUserResponse(res); 
        
        },
        err => { this.http.onEnd(); 
            this.showLoader = false;

        }
    );
 }

 public deleteUserResponse(res) {
    this.rowToDel = null;
    // var res = JSON.parse(res['_body']);
        if(res && res.message == 'success'){
          
            this.showLoader = false;

            this.http.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
           
                this.dialogRef.componentInstance.msg = "User deleted successfully.";
            this.dialogRef.afterClosed().subscribe(result => {
            this.reloadData();
            });
        }else if(res && res.message == 'error_occured'){

            this.showLoader = false;

            this.http.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.exp.message;

        
         } else {
            this.showLoader = false;

            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to perform action. Please try again.';
            this.http.onEnd();
        }
    }
    public saveDashboardData(res,filter) {
        // debugger;
            // if(res.status == 'Success') {
            if(res && Object.keys(res).length > 0 ){
                this.dashboardData = res;
                this.rows=[];
                this.rows['offSet'] = res.offSet;
                if(this.dashboardData && Object.keys(this.dashboardData).length > 0 ) {
                    if(this.dashboardData['items']) {
                        let totalCount = 0;
                    if(parseInt(res.offSet) == 0) {
                        localStorage.setItem('totalCount',res.itemCount);
                        totalCount = parseInt(res.itemCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }
                    this.rows['total_count'] = totalCount;
                    for (let data in this.dashboardData['items']) {
                       
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.dashboardData['items'][data]['id']; 
                            this.rows[data]['email'] = this.dashboardData['items'][data]['email'];
                            this.rows[data]['firstName'] = this.dashboardData['items'][data]['firstName'];
                            this.rows[data]['lastName'] = this.dashboardData['items'][data]['lastName'];
                            this.rows[data]['region'] = this.dashboardData['items'][data]['region'];
                            // this.rows[data]['alarmName'] = this.dashboardData['items'][data]["alarmDetails"]["alarmsName"];
                            // this.rows[data]['startTime'] = this.dashboardData['items'][data]["alarmDetails"]["startTime"];
                           let countriesArr = this.dashboardData['items'][data]["countries"];
                            var countries='';
                        for (var i in countriesArr) {
                        var obj = { "id": i, "name": countriesArr[i] };
                        countries += countriesArr[i]+',';
                        }
                        countries = countries.substring(0,countries.length-1);
                            this.rows[data]['country'] = countries;
                            // this.rows[data]['lastProcessedOn'] = this.dashboardData['items'][data]["lastProcessedOn"];
                            this.rows[data]['role'] = this.dashboardData['items'][data]["role"];
                //    if(this.rows[data]['creationTime'] !=""){
                //        alert(this.rows[data]['siteId']+" "+this.rows[data]['creationTime']);
                //    }
                   
                        }
                    this.showTable = true;
                    this.showLoader = false;
                    this.temp = this.rows;
                    //console.log(JSON.stringify(this.rows));
                    }
                }

            //   this.updateAllFilter(true);

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offSet' && f !='total_count' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offSet'){
                        finalRows['offSet'] = this.rows['offSet'];
                    }
                    if(f == 'total_count'){
                        finalRows['total_count'] = this.rows['total_count'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offSet']/this.page.size },finalRows,filter);
                this.http.onEnd();
            }
        // } else {
        //     this.dialogRef = this.dialog.open(dialogComponent);
        //     this.dialogRef.componentInstance.msg = res.errorMessage;
        //     this.http.onEnd();
        // }
    }


    /**
    * Populate the table with new data based on the page number
    * @param page The page to select
    */
    setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
            if(rows.length != 0){
                this.serverResultsService.getResults(this.page,rows).subscribe(pagedData => {
                    this.page = pagedData.page;
                    this.tableRows = pagedData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getDashboardData(this.filters);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }
  
      
public getLastWeek(){
    var today = new Date();
    var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    return lastWeek ;
}




  
 ngOnInit(){
     
    this.APPCONFIG =APPCONFIG;
    // APPCONFIG.navCollapsed = true;
    // this.cdr.detectChanges();
 }
    

}



